import { render, staticRenderFns } from "./NeoparentStatistics.vue?vue&type=template&id=3b215716&scoped=true"
import script from "./NeoparentStatistics.vue?vue&type=script&lang=js"
export * from "./NeoparentStatistics.vue?vue&type=script&lang=js"
import style0 from "./NeoparentStatistics.vue?vue&type=style&index=0&id=3b215716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b215716",
  null
  
)

export default component.exports